import { CreateSmsTemplateOffsetTenant, SmsTemplate, SmsTemplateService, UpdateSmsSenderId } from '@services';
import { message } from 'antd';
import { makeAutoObservable, runInAction } from 'mobx';

class SmsTemplateStore {
  smsTemplates: Map<number, SmsTemplate> = new Map();
  smsSenderId: string | null = null;
  loading: boolean = false;
  submitLoading: boolean = false;
  senderIdLoading: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  async getAll() {
    this.setLoading(true);
    try {
      const result = await SmsTemplateService.getAll();
      runInAction(() => {
        result.forEach((smsTemplate) => {
          this.smsTemplates.set(smsTemplate.id, smsTemplate);
        });
      });
      this.setLoading(false);
    } catch (error) {
      this.setLoading(false);
      console.error(error);
    }
  }

  async createSmsTemplateOffsetTenant(request: CreateSmsTemplateOffsetTenant) {
    this.setSubmitLoading(true);
    try {
      const result = await SmsTemplateService.createSmsTemplateOffsetTenant(request);
      this.setSubmitLoading(false);
      message.success({
        content: 'Successfully saved!',
      });
      return result;
    } catch (error) {
      this.setSubmitLoading(false);
      console.error(error);
      throw error;
    }
  }

  setLoading = (value: boolean) => {
    runInAction(() => {
      this.loading = value;
    });
  };

  setSubmitLoading = (value: boolean) => {
    runInAction(() => {
      this.submitLoading = value;
    });
  };

  clearSmsTemplates() {
    runInAction(() => {
      this.smsTemplates.clear();
    });
  }

  async getSmsSenderId() {
    runInAction(() => {
      this.senderIdLoading = true;
    });
    try {
      const result = await SmsTemplateService.getSmsSenderId();
      runInAction(() => {
        this.smsSenderId = result.smsSenderId;
        this.senderIdLoading = false;
      });
    } catch (error) {
      runInAction(() => {
        this.senderIdLoading = false;
      });
      console.error(error);
    }
  }

  async updateSmsSenderId(request: UpdateSmsSenderId) {
    this.setSubmitLoading(true);
    try {
      await SmsTemplateService.updateSmsSenderId(request);
      runInAction(() => {
        this.smsSenderId = request.smsSenderId;
        this.submitLoading = false;
      });
      message.success({ content: 'SMS sender name saved!' });
    } catch (error) {
      this.setSubmitLoading(false);
      console.error(error);
      throw error;
    }
  }
}

export default SmsTemplateStore;
